import { render, staticRenderFns } from "./KETKassenstart.vue?vue&type=template&id=005b2624&"
import script from "./KETKassenstart.vue?vue&type=script&lang=js&"
export * from "./KETKassenstart.vue?vue&type=script&lang=js&"
import style0 from "./KETKassenstart.vue?vue&type=style&index=0&id=005b2624&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports